export default __webpack_public_path__ + "static/media/file_copy.eeb7262b.svg";